import React from "react";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";

import ReactLoading from "react-loading";
import InputLabel from "@material-ui/core/InputLabel";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

class ReplicationStatus extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      alerts: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getReplicationStatus();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    // compare settings prop
    if (
      prevProps.memberSettings.repStatusDelay !==
      this.props.memberSettings.repStatusDelay
    ) {
      if (this._isMounted === true && this.state.isLoading === false) {
        this.setState({ isLoading: true });
      }
      this.getReplicationStatus();
    }
  }

  getReplicationStatus() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .post(`${BASE_URL}/api/alerts/replication`, {
        delay: this.props.memberSettings.repStatusDelay,
      })
      .then((response) => {
        if (this._isMounted === true) {
          this.setState({
            alerts: response.data,
            isLoading: false,
          });
        }
      })
      .catch((e) => console.log(e));
  }

  render() {
    const { classes } = this.props;

    const alertCards = this.state.alerts.map((alertsByLocation) => {
      return Object.keys(alertsByLocation).map((locationName) => {
        const locData = alertsByLocation[locationName];
        return (
          <GridItem key={locationName} xs={12} sm={12} md={4}>
            <Card>
              <CardHeader color={locData.color}>
                <h4 className={`${classes.cardTitleWhite}`}>
                  {locationName.replace(/_/g, " ")}
                </h4>
              </CardHeader>
              <CardBody>
                <GridItem xs={12} sm={12} md={12}>
                  <InputLabel>{`Latest Login: ${
                    locData.latestLogin
                  }`}</InputLabel>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <InputLabel>{`Latest Transaction: ${locData.latestTransaction}
                  `}</InputLabel>
                </GridItem>
              </CardBody>
            </Card>
          </GridItem>
        );
      });
    });
    return (
      <div>
        {this.state.isLoading === true ? (
          <CardBody>
            <ReactLoading
              type="spin"
              color="#000000"
              style={{
                width: "20%",
                margin: "auto",
              }}
            />
          </CardBody>
        ) : (
          <Card>
            <CardHeader color="success">
              <h4 className={`${classes.cardTitleWhite}`}>Status</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>{alertCards}</GridContainer>
            </CardBody>
          </Card>
        )}
      </div>
    );
  }
}

export default ReplicationStatus;



// WEBPACK FOOTER //
// ./src/components/Alerts/ReplicationStatus.jsx